












































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions } from '@/ts/store/Constants';
import AddButton from '@/components/Admin/Layout/AddButton.vue';
import AddDocumentButton from '@/components/Admin/Layout/AddDocumentButton.vue';
import AddEventButton from '@/components/Admin/Layout/AddEventButton.vue';
import SelectedItems from '@/components/Admin/Layout/SelectedItems.vue';
import EditProjectForm from '@/components/Admin/Forms/EditProjectForm.vue';
import ProjectListItem from '@/components/Admin/Lists/ProjectListItem.vue';
import AddNotificationButton from '@/components/Admin/Layout/AddNotificationButton.vue';
import ProjectsData from '@/ts/ProjectsData';
import AddDocumentForm from '@/components/Admin/Forms/AddDocumentForm.vue';
import EventFlyout from '@/components/Flyouts/EventFlyout.vue';
import BroadcastFlyout from '@/components/Flyouts/BroadcastFlyout.vue';
import ProjectList from '@/components/Admin/Lists/ProjectList.vue';
import Recipients from '@/components/Admin/Panels/Recipients.vue';

@Component({
    components: {
        AddButton,
        AddDocumentButton,
        AddEventButton,
        ProjectListItem,
        EditProjectForm,
        AddNotificationButton,
        SelectedItems,
        AddDocumentForm,
        EventFlyout,
        BroadcastFlyout,
        ProjectList,
        Recipients,
    },
    computed: {
        ...mapGetters({
            formVisible: 'Viewport/isAddFormVisible',
        }),
    },
})

export default class Projects extends Vue {
    @Prop() public items!: ProjectsData;
    public tabs: any[] = [
        {
            class : ' fa-th',
            status : true,
            config : 'grid',
        },
        {
            class : ' fa-list-ul',
            status : false,
            config : 'table',
        },
    ];

    constructor() {
        super();
    }

    get recipientsVisible(): boolean {
        return this.$store.getters['Recipients/getRecipientsVisible'];
    }

    get filteredProjects() {
        return this.$store.getters['Projects/allProjects'];
    }

    get projectConfigs() {
        return this.$store.getters['Projects/getProjectConfigs'];
    }

    get getProjectsData(): any {
        return this.$store.getters['Projects/allProjects'];
    }

    get activeProject(): ProjectsData {
        return this.$store.getters['Projects/activeProject'];
    }

    get hasSelectedProjects(): any {
        return this.$store.getters['Projects/selectedProjects'].length;
    }

    get hasSelectedBuildings(): any {
        return this.$store.getters['Buildings/selectedBuildings'].length;
    }

    get hasSelectedProperties(): any {
        return this.$store.getters['Properties/selectedProperties'].length;
    }

    get hasSelectedItem(): boolean {
        return this.hasSelectedProjects ||  this.hasSelectedBuildings || this.hasSelectedProperties;
    }

    get addMenuVisible() {
        return this.$store.getters['Viewport/menuVisible'];
    }

    get editMenuVisible() {
        return this.$store.getters['Projects/editMenuVisible'];
    }

    get editProjectFormVisible() {
        return this.$store.state.Projects.editFormVisible;
    }

    get addMenuClass() {
        return {
            activeForm: this.addMenuVisible,
        };
    }

    get editMenuClass() {
        return {
            activeForm: this.editMenuVisible,
        };
    }

    public addProject() {
        this.$store.dispatch(Actions.INITIATE_PROJECT);
        this.slideInForm('add-project');
    }

    public addNotification() {
        this.$store.dispatch(Actions.INITIATE_NOTIFICATION);
        this.slideInForm('add-notification');
    }

    public addDocument() {
        this.slideInForm('add-document');
    }

    public addEvent() {
        this.slideInForm('add-event');
    }

    public slideInForm(formKey: string) {
        this.$store.dispatch(Actions.SHOW_FORM, formKey);
    }

    public toggleTab(tabIndex: any, config: string) {
        if (config !== this.projectConfigs) {
            this.$store.dispatch(Actions.UPDATE_PROJECT_CONFIGS, config);
        }
    }

    public mounted() {
        this.$store.dispatch(Actions.FETCH_PROJECT_CONFIGS);
        this.$store.dispatch(Actions.FETCH_PROJECTS);
    }
}
